var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUturnLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2173 6.11536C21.8438 6.74182 21.8438 7.75753 21.2173 8.38399L11.1225 18.4788H32.9163C40.8899 18.4788 47.3538 24.9427 47.3538 32.9163C47.3538 40.8899 40.8899 47.3538 32.9163 47.3538H26.4997C25.6137 47.3538 24.8955 46.6356 24.8955 45.7497C24.8955 44.8637 25.6137 44.1455 26.4997 44.1455H32.9163C39.118 44.1455 44.1455 39.118 44.1455 32.9163C44.1455 26.7146 39.118 21.6872 32.9163 21.6872H11.1225L21.2173 31.782C21.8438 32.4085 21.8438 33.4242 21.2173 34.0507C20.5909 34.6771 19.5752 34.6771 18.9487 34.0507L6.11536 21.2173C5.48889 20.5909 5.48889 19.5752 6.11536 18.9487L18.9487 6.11536C19.5752 5.48889 20.5909 5.48889 21.2173 6.11536Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUturnLeft);
export default __webpack_public_path__ + "static/media/arrow-uturn-left.cc1b23c159a732bab3dc207c4c547c57.svg";
export { ForwardRef as ReactComponent };